import React from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import { Panel } from '@idealmediaworks/lookingglass-ui-framework';
import ChannelsArea from '../containers/channelsArea/ChannelsArea';

const PanelChannels: React.FC = (): JSX.Element => {
  return (
    <Panel>
      <ChannelsArea />
    </Panel>
  );
};

export default PanelChannels;
